<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="tableDisplay" class="float-right">
        <el-button type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>
        <a @click="Yazdir" class="el-button YeniBtn el-button--primary el-button--small"
        ><i class="feather-printer"></i> Yazdır
        </a>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <el-row :gutter="24">
        <div class="raporbloksabitle">

          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="4">
              <el-form-item label="Cari" prop="Cari_id">
                <el-select v-model="Form.Cari_id" filterable clearable>
                  <el-option
                    v-for="item in Cariler"
                    :key="item.id"
                    :label="item.Unvan"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Site / Bina" prop="Bina_id">
                <el-select v-model="Form.Bina_id" filterable clearable>
                  <el-option-group
                    label="Site Listesi">
                    <el-option
                      v-for="item in Siteler"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                  <el-option-group
                    label="Bina Listesi">
                    <el-option
                      v-for="item in Binalar"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Rapor Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item label="Kategori" prop="Kategori_id">
                <el-cascader
                  collapse-tags
                  :options="Kategoriler"
                  :props="{ multiple: true}"
                  v-model="Form.Kategori_id"
                  filterable></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item class="Tooltip" label="Detay" prop="Detay">
                <el-tooltip class="item" effect="dark"
                            content="Borç Ödenen ve Kalan detaylarını verir" placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-switch v-model="Form.Detay"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item class="Tooltip" label="Ödeme Dahil" prop="Guncel">
                <el-tooltip class="item" effect="dark"
                            content="Bütün ödemeleri dahil et" placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-switch v-model="Form.Guncel"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-button :disabled="lo" type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>

        </div>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">

          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <div class="yazdirtable">
            <h1>{{ Sayfa.Adi }}</h1>
            <table class="table table-bordered ">
              <thead>
              <tr>
                <th>Tarih</th>
                <th>Site/Bina</th>
                <th>Cari</th>
                <th>Kategori</th>
                <th>Açıklama</th>
                <th v-if="Detay" class="text-right">Borç</th>
                <th v-if="Detay" class="text-right">Ödenen</th>
                <th class="text-right">Kalan</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="t in tableData">
                <td>{{ t.Tarih }}</td>
                <td>{{ t.SiteBina }}</td>
                <td>{{ t.Cari }}</td>
                <td>{{ t.Kategori }}</td>
                <td>{{ t.Aciklama }}</td>
                <td v-if="Detay" class="text-right">{{ t.Borc }}</td>
                <td v-if="Detay" class="text-right">{{ t.Odenen }}</td>
                <td class="text-right">{{ t.Kalan }}</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th colspan="5" class="text-right">ALT TOPLAM</th>
                <th v-if="Detay" class="text-right">{{ AltToplam.Borc }}</th>
                <th v-if="Detay" class="text-right">{{ AltToplam.Odenen }}</th>
                <th class="text-right">{{ AltToplam.Kalan }}</th>
              </tr>
              </tfoot>
            </table>
          </div>
          <el-table
            v-if="tableDisplay"
            class="table-xs yazdirma"
            :data="tableData"
            style="width: 100%"
            width="100%"
            show-summary
            :height="Height"
            :summary-method="TableFooter"
          >
            <el-table-column
              label="Tarih"
              prop="Tarih"
              width="100">
            </el-table-column>
            <el-table-column
              label="SiteBina"
              prop="SiteBina"
              width="300">
            </el-table-column>
            <el-table-column
              label="Cari"
              prop="Cari"
              width="300">
            </el-table-column>
            <el-table-column
              label="Kategori"
              prop="Kategori"
              width="200">
            </el-table-column>
            <el-table-column
              label="Açıklama"
              prop="Aciklama">
            </el-table-column>
            <el-table-column
              label="Borç"
              v-if="Detay"
              prop="Borc"
              width="100"
              align="right">
            </el-table-column>
            <el-table-column
              label="Ödenen"
              v-if="Detay"
              prop="Odenen"
              width="100"
              align="right">
            </el-table-column>
            <el-table-column
              label="Kalan"
              prop="Kalan"
              width="100"
              align="right">
            </el-table-column>
          </el-table>
        </el-col>

      </el-row>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));

import Yukleniyor from "../../components/Doc/Yukleniyor";
import TableYazdir from "../../components/Yazdir/TableYazdir";

export default {
  components: {TableYazdir, Yukleniyor},
  data() {
    return {
      Height: 0,
      FiltreCollapse: '1',
      lo: false,
      Yetki: false,
      Kaydet: false,
      Sayfa: {
        Adi: 'Borç Listesi',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      Form: {
        Bina_id: null,
        Cari_id: null,
        Tarih: [],
        Kategori_id: null,
        Detay: true,
        Guncel: false,
      },
      FormHata: {
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      RaporAdi: "",
      Kategoriler: [],
      Binalar: [],
      Siteler: [],
      Cariler: [],
      tableData: [],
      ExcelData: [],
      tableDisplay: false,
      AltToplam: {
        Borc: 0,
        Odenen: 0,
        Kalan: 0
      },
      Detay: false

    }
  },
  methods: {

    Excel(evt) {
      const ws = XLSX.utils.json_to_sheet(this.ExcelData);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 20},
        {wch: 30},
        {wch: 40},
        {wch: 15},
        {wch: 50},
        {wch: 12},
        {wch: 12},
        {wch: 12},
      ];
      XLSX.utils.cell_set_number_format(ws['F2'], '0.00');
      wb.Props = {
        Title: this.Sayfa.Adi,
        Author: "Aidatim APP",
        Manager: "Aidatim APP",
        Company: "Aidatim",
        Category: "Finans",
        Keywords: "Aidatim",
        Comments: this.Sayfa.Adi,
      };
      XLSX.utils.book_append_sheet(wb, ws, this.RaporAdi);
      XLSX.writeFile(wb, this.RaporAdi + " " + this.Sayfa.Adi + ".xlsx");
    },
    Yazdir() {
      this.$prompt('Yazdırılacak sayfanın adını değişebilirsiniz.', 'Sayfa Adı', {
        confirmButtonText: 'Yazıcıya Gönder',
        cancelButtonText: 'Vazgeç',
        inputValue: this.Sayfa.Adi,
        inputPlaceholder: 'Yazdırma Sayfası'
      }).then(({value}) => {
        this.Sayfa.Adi = value;
        this.YaziciyaGonder(value);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Yazdırma İptal Edildi'
        });
      });
    },
    YaziciyaGonder() {
      setTimeout(() => {
        window.print();
      }, 100);
    },
    TableClass({row}) {
      return row.TableClass
    },
    TableFooter() {
      const sums = [];

      if (this.Detay) {
        sums[5] = this.AltToplam.Borc;
        sums[6] = this.AltToplam.Odenen;
        sums[7] = this.AltToplam.Kalan;
      } else {
        sums[5] = this.AltToplam.Kalan;
      }


      return sums;
    },
    Getir() {
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.Detay = this.Form.Detay;
          this.$store.dispatch("Post", {...this.Form, path: 'raporlama/borc/'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.tableData = response.tableData;
                this.AltToplam = response.AltToplam;
                this.ExcelData = response.ExcelData;
                this.RaporAdi = response.RaporAdi;
                if (this.tableData) this.tableDisplay = true;
                this.Height = window.innerHeight - 220
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })

    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Kategoriler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'muhasebe/cari'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Cariler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'muhasebe/list/bina'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Binalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'muhasebe/list/site'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Siteler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    },
  },
  created() {
    this.SayfaYukle();
    this.Yetki = this.$store.getters.Yetki.raporlama == 2 ? true : false;
    var Gun = new Date();
    this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    if (this.$store.getters.BinaBilgi) {
      this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
    }
  },

}
</script>



// WEBPACK FOOTER //
// src/pages/Raporlama/borc.vue